import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/vercel/path0/src/components/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureCards"] */ "/vercel/path0/src/components/FeatureCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/vercel/path0/src/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonials"] */ "/vercel/path0/src/components/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkGallery"] */ "/vercel/path0/src/components/WorkGallery.tsx");
